<script>
    import AdminFamilyPeople from './AdminFamilyPeople.svelte';

    import { db } from './firebase';
    import { collectionData } from 'rxfire/firestore';
    import { startWith } from 'rxjs/operators';
    import { month2Human } from './util';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let family;
    $: peopleCount = family.people.length + 1;

    function edit() {
        dispatch('edit', { family });
    }
    function doDelete() {
        dispatch('delete', { family });
    }

    const transactionsQuery =
        db
            .collection('transactions')
            .where('family', '==', db.collection("families").doc(family.id));
            // .orderBy('time');
    const txs =
        collectionData(transactionsQuery, 'id')
            .pipe(startWith([]));

    function uid2user(uid) {
        const user = family.people.find(x => x.uid === uid);
        if (user) {
            return user.name;
        } else {
            return 'Neznámý uživatel';
        }
    }

    $: link = `https://dluhy.remus32.cz/xxx/${family.id}`
</script>

<div>
    Jméno: <b>{family.name}</b>
    (<b>{peopleCount}</b> členů z {family.maxPeople},
    <b>{family.monthlyPayment}</b> Kč/měsíc,
    <b>{family.monthlyPayment / peopleCount}</b> Kč/os.měsíc,
    od: {month2Human(family.firstMonth)})
    <button type=button on:click={edit}>Upravit</button>
    <button type=button on:click={doDelete}>Smazat</button>
    <br>
    Přidávací link: <a href={link}>{link}</a>
    <br>
    <AdminFamilyPeople {family} {txs} />
    <br>
    <ul>
        {#each $txs as tx (tx.id)}
            {@debug tx}
            <li>
                {tx.time.toDate().toLocaleString()} - {uid2user(tx.uid)} - {tx.amount} kč
            </li>
        {/each}
    </ul>
</div>